import { createContext } from 'react';

import { PreviewHighlight } from '../types';

type PreviewHighlightContextType = {
  highlight: PreviewHighlight;
  setHighlight: (highlight: PreviewHighlight) => void;
  viewportWidth?: number;
  viewportHeight?: number;
};

export const PreviewHighlightContext =
  createContext<PreviewHighlightContextType>({
    highlight: null,
    setHighlight: () => undefined,
  });
